import { fg } from '@atlaskit/platform-feature-flags';

export const calculateRemainingMinutesAndSeconds = (countDown: number) => {
	const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
	const seconds = Math.floor((countDown % (1000 * 60)) / 1000);
	return [minutes < 0 ? 0 : minutes, seconds < 0 ? 0 : seconds];
};

export const getTargetAccountIdSuffix = (targetAccountId: string | undefined | null) => {
	if (fg('jsm_admin_access_user_notification_settings')) {
		return targetAccountId ? `?targetAccountId=${targetAccountId}` : '';
	}
	return '';
};
